import PartnerOpportunitiesPage from '@/pages/PartnerOpportunitiesPage';

/** Legacy paid-ads URL — full partner opportunities page with connect lead tracking. */
function PartnerLandingPage() {
  return <PartnerOpportunitiesPage source="connect" />;
}

export default PartnerLandingPage;
